<template>
  <div id="app">
      <!-- header部分 -->
      <div style="position:fixed;z-index:10;top:0px;width:100%;">
      <div style="width:100%;height:38px;background:#fff;position:relative;">
        <img style="position:absolute;left:180px;bottom:-14px;width:23px;height:25px;" src="../assets/water_icon.png">
      </div>
      <div class="header">
          <div class="logo_img" @click="logoClick">
              <div style="display:flex; align-items: center; float:left; height: 71px;">
                  <div class="header-logo">
                      <img id="header-img" src="../assets/logo.png" >
                  </div>
              </div>
          </div>
          <div id="menu_index">
              <!-- web端菜单导航 -->
              <el-menu background-color="#00546a" text-color="#fff" active-text-color="#fff" :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                  <el-menu-item index="2">
                    <span style="font-size:18px;font-weight:bold;">Product</span>
                    <!-- <img style="margin-left:8px" src="../assets/arrow1.png" > -->
                  </el-menu-item>
                  <el-menu-item index="3">
                    <span style="font-size:18px;font-weight:bold;">Support</span>
                    <!-- <img style="margin-left:8px" src="../assets/arrow1.png" > -->
                  </el-menu-item>
                  <el-submenu index="4" style="margin-left:20px;" class="dddd">
                    <template slot="title">
                      <span style="font-size:18px;font-weight:bold;">Company</span>
                      <img style="margin-left:8px" src="../assets/arrow1.png" >
                    </template>
                    <el-menu-item index="4-1">News and events</el-menu-item>
                    <el-menu-item index="4-2">Offices</el-menu-item>
                    <el-menu-item index="4-3">About us</el-menu-item>
                    <el-menu-item index="4-4">Career</el-menu-item>
                  </el-submenu>
              </el-menu>
          </div>
          <div style="float: right; display: flex;align-items: center; height: 100%;">
              <a class="a1" @click="contactDetail"><img style="width:24px;height:24px;margin-right:23px;" src="../assets/phone_icon.png"></a>
              <a class="a1" @click="goCart"><img style="width:24px;height:24px;margin-right:23px;" src="../assets/cart_icon.png"></a>
              <!-- <aclass="a1"><img style="width:31px;height:31px;margin-right:23px;" src="../assets/language_icon.png"></a> -->
              <el-popover popper-class='my-popper' trigger="click" style="padding:0;">
                <a class="a1" slot="reference"><img style="width:24px;height:24px;margin-right:23px;" src="../assets/language_icon.png"></a>
                <div style="background:#f5f5f5;padding:20px 30px 38px 30px;">
                  <!-- <el-dropdown-item></el-dropdown-item> -->
                  <!-- <el-dropdown-item></el-dropdown-item> -->
                  <div>
                    <p style="max-width:264px;line-height:24px;font-size:16px;color:#000;">We have set your country/regionto United States</p>
                    <p style="max-width:264px;line-height:24px;font-size:16px;color:#000;margin:15px 0 10px 0;">You can change this selection atany time, but products in yourcart, saved lists, or quote may beremoved if they are unavailable inthe new shipping country/region.</p>
                    <p style="font-size:16px;color:#000;font-weight:bold;">Select Your Country/Region</p>
                  </div>
                  <div>
                    <!-- <el-input  style="margin-bottom:12px;"></el-input> -->
                    <el-select v-model="countrtValue" placeholder="" style="margin:15px 0 25px 0px;width:264px;">
                      <el-option
                          v-for="item in countryOptions"
                          :key="item.value"
                          :label="item.label"
                          style="width:264px;"
                          :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div>
                    <a class="a1" style="padding:10px 23px;background:#00718c;color:#fff;font-size:20px;">SUBMIT</a>
                  </div>
                </div>
              </el-popover>
              <!-- <el-dropdown>
                <a class="a1" @click="goLogin"><img style="width:28px;height:32px;margin-right:23px;" src="../assets/account_icon.png"></a>
                <el-dropdown-menu slot="dropdown" style="background-color:#00546a;color:#fff;">
                  <el-dropdown-item>个人中心</el-dropdown-item>
                  <el-dropdown-item>退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
              <a v-if="!this.isShowToken" class="a1" @click="goLogin"><img style="width:24px;height:24px;margin-right:23px;" src="../assets/account_icon.png"></a>
              <el-menu v-else background-color="#00546a" text-color="#fff" active-text-color="#fff" :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
                  <el-submenu>
                    <template slot="title">
                      <a class="a1"><img style="width:24px;height:27px;margin-right:16px;margin-top:-10px;" src="../assets/account_icon.png"></a>
                    </template>
                    <el-menu-item @click="goAccount">个人中心</el-menu-item>
                    <el-menu-item @click="goLaout">退出</el-menu-item>
                  </el-submenu>
              </el-menu>
              <a @click="goSearch" class="a1"><img style="width:24px;height:24px;margin-right:23px;" src="../assets/search_icon.png"></a>
              <!-- <el-button type="text" style="margin-right: 20px;" class="header-title" @click="login">登录</el-button>
              <el-button type="primary" class="header-title" @click="register" round>注册</el-button> -->
          </div>
      </div>
      <div v-if="isShowSearch" style="height:50px;width:100%;border:1px solid ##00546a;position:relative;line-height:50px;background:#fff;">
        <img src="../assets/support_search.png" @click="getSearchList" style="width:28px;height:28px;position:absolute;right:10%;top:13px;z-index:2;">
        <el-input class="search_input" clearable v-model="keyword" @change="getSearchList" placeholder="Search products"></el-input>
        <i class="el-icon-close" @click="goDelete" style="position:absolute;right:50px;top:20px"></i>
      </div>
      </div>
      
      <div class="container" style="clear: both;padding-top:109px;">
          <router-view></router-view>
      </div>
      <!-- footer部分 -->
      <div class="footer" style="position:relative">
         <img style="position:absolute;left:202px;top:-14px;width:23px;height:25px;" src="../assets/water_icon.png">
         <div class="footer_content">
            <div style="width:26%"><img id="header-img" src="../assets/logo.png" ></div>
            <ul style="width:16%;">
              <li style="font-size:18px;font-weight:bold;margin-bottom:10px;">Quick Links</li>
              <li style="font-size:16px;margin-bottom:10px;color:#cad4d9;" @click="contactDetail"><a class="a1">Contact Us</a></li>
              <!-- <li style="font-size:16px;color:#cad4d9;"><a class="a1" @click="goSuport">support</a></li> -->
              <li style="font-size:16px;color:#cad4d9;"><a class="a1">FAQ</a></li>
            </ul>
            <ul style="width:16%;">
              <li style="font-size:18px;font-weight:bold;margin-bottom:10px;">How to Buy</li>
              <li style="font-size:16px;margin-bottom:10px;color:#cad4d9;"><a class="a1" style="color:#cad4d9;" href="mailto:service@kelliop.com?subject=Electronic%20quotation%20">Get a Quote</a></li>
              <li style="font-size:16px;color:#cad4d9;"><a class="a1" @click="goLogin">Sign up</a></li>
            </ul>
            <!-- <ul style="width:24%;">
              <li style="font-size:18px;margin-bottom:10px;font-weight:bold">cooperation</li>
              <li style="font-size:16px;margin-bottom:10px;color:#cad4d9;"><a class="a1" target="_blank" style="color:#cad4d9" href="https://www.dbs.nus.edu.sg/">Singapore Institute for Clinical Sciences</a></li>
              <li style="font-size:16px;color:#cad4d9;"><a class="a1" target="_blank" style="color:#cad4d9" href="https://klv.whu.edu.cn/">State Key Laboratory of Virology</a></li>
            </ul> -->
            <ul style="width:24%;">
              <li style="font-size:18px;margin-bottom:10px;font-weight:bold">Resources</li>
              <li style="font-size:16px;margin-bottom:10px;color:#cad4d9;"><a class="a1">Media</a></li>
              <li style="font-size:16px;color:#cad4d9;"><a class="a1"  @click="goSuport">Support</a></li>
            </ul>
            <ul style="width:18%;">
              <li style="font-size:18px;font-weight:bold">Follow kelliop</li>
              <!-- <li><img style="width:106px;height:26px;margin-top:16px;" src="../assets/footer_icon.png"></li> -->
              <li>
                <a style="color:#cad4d9;width:32px;height:32px;float:left;margin-top:16px;margin-left:-6%;" target="_blank" href="https://www.facebook.com/profile.php?id=100091323908268&mibextid=2JQ9oc"><img style="width:32px;height:32px;" src="../assets/fonter_icon01.png" /></a>
                <a style="color:#cad4d9;width:32px;height:32px;float:left;margin-top:16px;margin-left:6%;" target="_blank" href="https://twitter.com/kelliop90307"><img style="width:32px;height:32px;" src="../assets/fonter_icon02.png" /></a>
              </li>
            </ul>
         </div>
         <div class="footer_bt">
           <!-- <span style="font-size:16px;">Copyright © kelliop Technologies Co., Ltd. All Rights Reserved. | ICP Placeholder</span> -->
           <span style="font-size:16px;">Sitemap  |  Terms Of Use  |  Privacy Statement</span>
         </div>
      </div>
      <!-- 返回top -->
      <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
          <i class="el-icon-upload2"></i>
      </div>
  </div>
</template>

<script>
  import {  productSearch } from '@/api/index' ;
  import bus from '@/bus/index';
  export default {
      name: "Layout",
      data() {
          return {
              activeIndex: '1',
              company:{
                  qrcode: require("../../static/other/公众号二维码.jpg"),
              },
              scroll: '',
              timer: '',
              currentMenu:'首页',
              isShowToken: '',
              isShowSearch: false,
              countryOptions: [
                {"value": "Afghanistan", "label": "Afghanistan"},
                {"value": "Aland Islands", "label": "Aland Islands"},
                {"value": "Albania", "label": "Albania"},
                {"value": "Algeria", "label": "Algeria"},
                {"value": "American Samoa", "label": "American Samoa"},
                {"value": "Andorra", "label": "Andorra"},
                {"value": "Angola", "label": "Angola"},
                {"value": "Anguilla", "label": "Anguilla"},
                {"value": "Antigua and Barbuda", "label": "Antigua and Barbuda"},
                {"value": "Argentina", "label": "Argentina"},
                {"value": "Armenia", "label": "Armenia"},
                {"value": "Aruba", "label": "Aruba"},
                {"value": "Australia", "label": "Australia"},
                {"value": "Austria", "label": "Austria"},
                {"value": "Azerbaijan", "label": "Azerbaijan"},
                {"value": "Bangladesh", "label": "Bangladesh"},
                {"value": "Bahrain", "label": "Bahrain"},
                {"value": "Bahamas", "label": "Bahamas"},
                {"value": "Barbados", "label": "Barbados"},
                {"value": "Belarus", "label": "Belarus"},
                {"value": "Belgium", "label": "Belgium"},
                {"value": "Belize", "label": "Belize"},
                {"value": "Benin", "label": "Benin"},
                {"value": "Bermuda", "label": "Bermuda"},
                {"value": "Bhutan", "label": "Bhutan"},
                {"value": "Bolivia", "label": "Bolivia"},
                {"value": "Bosnia and Herzegovina", "label": "Bosnia and Herzegovina"},
                {"value": "Botswana", "label": "Botswana"},
                {"value": "Bouvet Island", "label": "Bouvet Island"},
                {"value": "Brazil", "label": "Brazil"},
                {"value": "Brunei", "label": "Brunei"},
                {"value": "Bulgaria", "label": "Bulgaria"},
                {"value": "Burkina Faso", "label": "Burkina Faso"},
                {"value": "Burundi", "label": "Burundi"},
                {"value": "Cambodia", "label": "Cambodia"},
                {"value": "Cameroon", "label": "Cameroon"},
                {"value": "Canada", "label": "Canada"},
                {"value": "Cape Verde", "label": "Cape Verde"},
                {"value": "Central African Republic", "label": "Central African Republic"},
                {"value": "Chad", "label": "Chad"},
                {"value": "Chile", "label": "Chile"},
                {"value": "Christmas Islands", "label": "Christmas Islands"},
                {"value": "Cocos (keeling) Islands", "label": "Cocos (keeling) Islands"},
                {"value": "Colombia", "label": "Colombia"},
                {"value": "Comoros", "label": "Comoros"},
                {"value": "Congo (Congo-Kinshasa)", "label": "Congo (Congo-Kinshasa)"},
                {"value": "Congo", "label": "Congo"},
                {"value": "Cook Islands", "label": "Cook Islands"},
                {"value": "Costa Rica", "label": "Costa Rica"},
                {"value": "Cote D'Ivoire", "label": "Cote D'Ivoire"},
                {"value": "China", "label": "China"},
                {"value": "Croatia", "label": "Croatia"},
                {"value": "Cuba", "label": "Cuba"},
                {"value": "Czech", "label": "Czech"},
                {"value": "Cyprus", "label": "Cyprus"},
                {"value": "Denmark", "label": "Denmark"},
                {"value": "Djibouti", "label": "Djibouti"},
                {"value": "Dominica", "label": "Dominica"},
                {"value": "East Timor", "label": "East Timor"},
                {"value": "Ecuador", "label": "Ecuador"},
                {"value": "Egypt", "label": "Egypt"},
                {"value": "Equatorial Guinea", "label": "Equatorial Guinea"},
                {"value": "Eritrea", "label": "Eritrea"},
                {"value": "Estonia", "label": "Estonia"},
                {"value": "Ethiopia", "label": "Ethiopia"},
                {"value": "Faroe Islands", "label": "Faroe Islands"},
                {"value": "Fiji", "label": "Fiji"},
                {"value": "Finland", "label": "Finland"},
                {"value": "France", "label": "France"},
                {"value": "Franch Metropolitan", "label": "Franch Metropolitan"},
                {"value": "Franch Guiana", "label": "Franch Guiana"},
                {"value": "French Polynesia", "label": "French Polynesia"},
                {"value": "Gabon", "label": "Gabon"},
                {"value": "Gambia", "label": "Gambia"},
                {"value": "Georgia", "label": "Georgia"},
                {"value": "Germany", "label": "Germany"},
                {"value": "Ghana", "label": "Ghana"},
                {"value": "Gibraltar", "label": "Gibraltar"},
                {"value": "Greece", "label": "Greece"},
                {"value": "Grenada", "label": "Grenada"},
                {"value": "Guadeloupe", "label": "Guadeloupe"},
                {"value": "Guam", "label": "Guam"},
                {"value": "Guatemala", "label": "Guatemala"},
                {"value": "Guernsey", "label": "Guernsey"},
                {"value": "Guinea-Bissau", "label": "Guinea-Bissau"},
                {"value": "Guinea", "label": "Guinea"},
                {"value": "Guyana", "label": "Guyana"},
                {"value": "Hong Kong", "label": "Hong Kong"},
                {"value": "Haiti", "label": "Haiti"},
                {"value": "Honduras", "label": "Honduras"},
                {"value": "Hungary", "label": "Hungary"},
                {"value": "Iceland", "label": "Iceland"},
                {"value": "India", "label": "India"},
                {"value": "Indonesia", "label": "Indonesia"},
                {"value": "Iran", "label": "Iran"},
                {"value": "Iraq", "label": "Iraq"},
                {"value": "Ireland", "label": "Ireland"},
                {"value": "Isle of Man", "label": "Isle of Man"},
                {"value": "Israel", "label": "Israel"},
                {"value": "Italy", "label": "Italy"},
                {"value": "Jamaica", "label": "Jamaica"},
                {"value": "Japan", "label": "Japan"},
                {"value": "Jersey", "label": "Jersey"},
                {"value": "Jordan", "label": "Jordan"},
                {"value": "Kazakstan", "label": "Kazakstan"},
                {"value": "Kenya", "label": "Kenya"},
                {"value": "Kiribati", "label": "Kiribati"},
                {"value": "Korea (South)", "label": "Korea (South)"},
                {"value": "Korea (North)", "label": "Korea (North)"},
                {"value": "Kuwait", "label": "Kuwait"},
                {"value": "Kyrgyzstan", "label": "Kyrgyzstan"},
                {"value": "Laos", "label": "Laos"},
                {"value": "Latvia", "label": "Latvia"},
                {"value": "Lebanon", "label": "Lebanon"},
                {"value": "Lesotho", "label": "Lesotho"},
                {"value": "Liberia", "label": "Liberia"},
                {"value": "Libya", "label": "Libya"},
                {"value": "Liechtenstein", "label": "Liechtenstein"},
                {"value": "Lithuania", "label": "Lithuania"},
                {"value": "Luxembourg", "label": "Luxembourg"},
                {"value": "Macau", "label": "Macau"},
                {"value": "Macedonia", "label": "Macedonia"},
                {"value": "Malawi", "label": "Malawi"},
                {"value": "Malaysia", "label": "Malaysia"},
                {"value": "Madagascar", "label": "Madagascar"},
                {"value": "Maldives", "label": "Maldives"},
                {"value": "Mali", "label": "Mali"},
                {"value": "Malta", "label": "Malta"},
                {"value": "Marshall Islands", "label": "Marshall Islands"},
                {"value": "Martinique", "label": "Martinique"},
                {"value": "Mauritania", "label": "Mauritania"},
                {"value": "Mauritius", "label": "Mauritius"},
                {"value": "Mayotte", "label": "Mayotte"},
                {"value": "Mexico", "label": "Mexico"},
                {"value": "Micronesia", "label": "Micronesia"},
                {"value": "Moldova", "label": "Moldova"},
                {"value": "Monaco", "label": "Monaco"},
                {"value": "Mongolia", "label": "Mongolia"},
                {"value": "Montenegro", "label": "Montenegro"},
                {"value": "Montserrat", "label": "Montserrat"},
                {"value": "Morocco", "label": "Morocco"},
                {"value": "Mozambique", "label": "Mozambique"},
                {"value": "Myanmar", "label": "Myanmar"},
                {"value": "Namibia", "label": "Namibia"},
                {"value": "Nauru", "label": "Nauru"},
                {"value": "Nepal", "label": "Nepal"},
                {"value": "Netherlands", "label": "Netherlands"},
                {"value": "New Caledonia", "label": "New Caledonia"},
                {"value": "New Zealand", "label": "New Zealand"},
                {"value": "Nicaragua", "label": "Nicaragua"},
                {"value": "Niger", "label": "Niger"},
                {"value": "Nigeria", "label": "Nigeria"},
                {"value": "Niue", "label": "Niue"},
                {"value": "Norfolk Island", "label": "Norfolk Island"},
                {"value": "Norway", "label": "Norway"},
                {"value": "Oman", "label": "Oman"},
                {"value": "Pakistan", "label": "Pakistan"},
                {"value": "Palau", "label": "Palau"},
                {"value": "Palestine", "label": "Palestine"},
                {"value": "Panama", "label": "Panama"},
                {"value": "Papua New Guinea", "label": "Papua New Guinea"},
                {"value": "Paraguay", "label": "Paraguay"},
                {"value": "Peru", "label": "Peru"},
                {"value": "Philippines", "label": "Philippines"},
                {"value": "Pitcairn Islands", "label": "Pitcairn Islands"},
                {"value": "Poland", "label": "Poland"},
                {"value": "Portugal", "label": "Portugal"},
                {"value": "Puerto Rico", "label": "Puerto Rico"},
                {"value": "Qatar", "label": "Qatar"},
                {"value": "Reunion", "label": "Reunion"},
                {"value": "Romania", "label": "Romania"},
                {"value": "Rwanda", "label": "Rwanda"},
                {"value": "Russian Federation", "label": "Russian Federation"},
                {"value": "Saint Helena", "label": "Saint Helena"},
                {"value": "Saint Kitts-Nevis", "label": "Saint Kitts-Nevis"},
                {"value": "Saint Lucia", "label": "Saint Lucia"},
                {"value": "Saint Vincent and the Grenadines", "label": "Saint Vincent and the Grenadines"},
                {"value": "El Salvador", "label": "El Salvador"},
                {"value": "Samoa", "label": "Samoa"},
                {"value": "San Marino", "label": "San Marino"},
                {"value": "Sao Tome and Principe", "label": "Sao Tome and Principe"},
                {"value": "Saudi Arabia", "label": "Saudi Arabia"},
                {"value": "Senegal", "label": "Senegal"},
                {"value": "Seychelles", "label": "Seychelles"},
                {"value": "Sierra Leone", "label": "Sierra Leone"},
                {"value": "Singapore", "label": "Singapore"},
                {"value": "Serbia", "label": "Serbia"},
                {"value": "Slovakia", "label": "Slovakia"},
                {"value": "Slovenia", "label": "Slovenia"},
                {"value": "Solomon Islands", "label": "Solomon Islands"},
                {"value": "Somalia", "label": "Somalia"},
                {"value": "South Africa", "label": "South Africa"},
                {"value": "Spain", "label": "Spain"},
                {"value": "Sri Lanka", "label": "Sri Lanka"},
                {"value": "Sudan", "label": "Sudan"},
                {"value": "Suriname", "label": "Suriname"},
                {"value": "Swaziland", "label": "Swaziland"},
                {"value": "Sweden", "label": "Sweden"},
                {"value": "Switzerland", "label": "Switzerland"},
                {"value": "Syria", "label": "Syria"},
                {"value": "Tajikistan", "label": "Tajikistan"},
                {"value": "Tanzania", "label": "Tanzania"},
                {"value": "Taiwan", "label": "Taiwan"},
                {"value": "Thailand", "label": "Thailand"},
                {"value": "Trinidad and Tobago", "label": "Trinidad and Tobago"},
                {"value": "Timor-Leste", "label": "Timor-Leste"},
                {"value": "Togo", "label": "Togo"},
                {"value": "Tokelau", "label": "Tokelau"},
                {"value": "Tonga", "label": "Tonga"},
                {"value": "Tunisia", "label": "Tunisia"},
                {"value": "Turkey", "label": "Turkey"},
                {"value": "Turkmenistan", "label": "Turkmenistan"},
                {"value": "Tuvalu", "label": "Tuvalu"},
                {"value": "Uganda", "label": "Uganda"},
                {"value": "Ukraine", "label": "Ukraine"},
                {"value": "United Arab Emirates", "label": "United Arab Emirates"},
                {"value": "United Kingdom", "label": "United Kingdom"},
                {"value": "United States", "label": "United States"},
                {"value": "Uruguay", "label": "Uruguay"},
                {"value": "Uzbekistan", "label": "Uzbekistan"},
                {"value": "Vanuatu", "label": "Vanuatu"},
                {"value": "Vatican City", "label": "Vatican City"},
                {"value": "Venezuela", "label": "Venezuela"},
                {"value": "Vietnam", "label": "Vietnam"},
                {"value": "Wallis and Futuna", "label": "Wallis and Futuna"},
                {"value": "Western Sahara", "label": "Western Sahara"},
                {"value": "Yemen", "label": "Yemen"},
                {"value": "Yugoslavia", "label": "Yugoslavia"},
                {"value": "Zambia", "label": "Zambia"},
                {"value": "Zimbabwe", "label": "Zimbabwe"}
              ],
              countrtValue: '',
              keyword: '',
              searchList: [],
          };
      },
      created() {
        this.isShowToken = localStorage.getItem('token');
      },
      methods: {
          handleSelect(key) {
              switch (key){
                case '2':
                  this.$router.push({name: "Product"});
                  break;
                case '3':
                  this.$router.push({name: "Support"});
                  break;
                case '4-1':
                  this.$router.push({name: "Newsevents"});
                  break;
                case '4-2':
                  this.$router.push({name: "Offices"});
                  break;
                case '4-3':
                  this.$router.push({name: "Abouts"});
                  break;
                case '4-4':
                  this.$router.push({name: "Career"});
                  break;
              }
          },
          handleScroll(){
              this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
              if( this.scroll >600 ){  //判断滚动后高度超过400px,就显示
                  this.$refs.btn.style.display = 'block';
              }else{
                  this.$refs.btn.style.display = 'none'
              }
          },
          backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
              this.timer = setInterval(() => {
                  let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                  let ispeed = Math.floor(-osTop / 5)
                  document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                  if (osTop === 0) {
                      clearInterval(this.timer)
                  }
              }, 30)
          },
          logoClick(){
              this.$router.push({name: "Index"});
              this.currentMenu='首页';
          },
          contactDetail() {
            this.$router.push({name: "Contact"});
          },
          goLogin() {
            this.$router.push({name: "Login"});
          },
          goAccount() {
            this.$router.push({name: "PersonalInformation"});
          },
          goLaout() {
            localStorage.removeItem('token');
            this.$router.replace({path:'/Login'})
            window.location.reload();
          },
          // 添加购物车
          goCart() {
            this.$router.push({name: "Cart"});
          },
          goDelete() {
            this.isShowSearch = false;
          },
          goSearch() {
            this.isShowSearch = true;
          },
          goSuport() {
            this.$router.push({name: "Support"});
          },
          // 搜索产品
          getSearchList() {
            console.log(this.keyword, 'keyword');
            if (this.keyword != '') {
              productSearch({keyword: this.keyword}).then((res) => {
                this.isShowSearch = false;
                console.log(res, 'resss');
                this.searchList = res.products;
                localStorage.setItem('searchList', JSON.stringify(this.searchList))
                this.$router.push({name: "Searchproduct"});
                bus.$emit('searchKey',this.keyword)
              });
            } else {
              window.location.reload();
              localStorage.setItem('searchList', JSON.stringify([]))
              this.$router.push({name: "Searchproduct"});
              bus.$emit('searchKey','')
            }
          },
      },
      mounted() {
          window.addEventListener('scroll', this.handleScroll)
      },
      computed: {},
  }
</script>

<style scoped>
  .logo_img{
      float:left;
      /* width: 18%; */
      cursor: pointer;
      margin-left:30px;
  }
  #back_to_top{
      position: fixed;
      bottom: 50px;
      right: 30px;
      cursor: pointer;
      border-radius: 50%;
      width:40px;
      height:40px;
      line-height:40px;
      text-align:center;
      background:#ccc;
      opacity: 0.6;
  }
  .header-title{
      font-size: 1em;
  }
  .company_name{
      font-weight: normal;
      font-size: 1em;
  }
  #menu_index{
      float: left;
      /* width: 50%; */
      height: 100%;
      margin-left: 25%;
  }
  .header{
      margin: auto;
      width: 100%;
      height: 71px;
      background: #00546a;
      box-shadow: 6px 0 9px rgba(0, 84, 106, 0.9)
  }
  @media screen and (max-device-width: 415px) {
      .logo_img{
          float:left;
          width: auto;
          cursor: pointer;
      }
      #back_to_top{
          position: fixed;
          bottom: 50px;
          right: 5px;
          cursor: pointer
      }
      #menu_index{
          float: right;
          width: auto;
          height: 100%
      }
      .mobile_menu{

      }
  }
  #header-img{
      width: 239px;
      height: 28px;
      float: left;
      margin: auto;
  }
  .header-logo{
      height: 28px;
      width: 239px;
      align-self: center;
  }
  .header-important{
      float: left;
      margin-left: 6px;
      align-self: center;
  }

  a{text-decoration: none;}
  a:visited{text-decoration: none;}
  a:hover {text-decoration: none;}
  a:active{text-decoration:none;}
  .el-menu-demo {
    height: 71px;
    border:0;
  }
  .el-menu-item {
    height: 71px;
    line-height: 71px;
  }
  .is-active {
    height: 70px;
    line-height: 70px;
  }
  .footer {
    width:100%;
    background:#00546a;
    color:#fff;
  }
  .footer_content {
    display:flex;
    height: auto;
    justify-content: space-between;
    padding:15px 36px 15px 53px ;
  }
  .footer_bt {
    height: auto;
    /* display:flex;
    align-items: center;
    justify-content: space-between; */
    padding:20px 36px 15px 53px ;
    text-align:right;
  }
  ::v-deep .dddd .el-icon-arrow-down:before{
    content: '' !important;
  }
  ::v-deep .el-menu--horizontal>.el-submenu .el-submenu__title{
    height:71px;
    line-height:71px;
  }
  ::v-deep .el-submenu__title {
    padding:0;
  }
  .search_input {
    width:400px;
    position: absolute;
    right: 8%;
    top: 0px;
  }
  /* ::v-deep .el-submenu {
    padding:0 20px;
  } */
  /* ::v-deep .el-popover{
    padding: 0px !important;
  }
  ::v-deep .el-popper{
    padding: 0px !important;
  } */
  
</style>
<style>
.my-popper{
    padding: 0;
  }
/* ::v-deep .el-popover{
    padding: 0px !important;
  }
  ::v-deep .el-popper{
    padding: 0px !important;
  } */
</style>